<template>
  <div class="vessel-course-icon" :style="cssVars">
    <vessel-course-safe v-if="isSafe" />
    <vessel-course-caution v-else-if="isCaution" />
    <vessel-course-danger v-else />
  </div>
</template>

<script>
import VesselCourseSafe from "./VesselCourseSafe.vue";
import VesselCourseCaution from "./VesselCourseCaution.vue";
import VesselCourseDanger from "./VesselCourseDanger.vue";
import C from "../../../Constants";
const { CAUTION, DANGER, SAFE } = C.RG_RISK_LEVEL;

export default {
  name: "VesselCourseIcon",
  components: {
    VesselCourseSafe,
    VesselCourseCaution,
    VesselCourseDanger,
  },
  props: {
    riskLevel: {
      type: Number, // SAFE(0) | CAUTION(3) | DANGER(8)
      default: CAUTION,
    }, // 色の切り替え
    hasManualAssessment: {
      type: Boolean,
      default: false,
    }, // 枠の表示非表示を切り替え
  },
  computed: {
    isSafe() {
      return this.riskLevel === SAFE;
    },
    isCaution() {
      return this.riskLevel === CAUTION;
    },
    isDanger() {
      return this.riskLevel === DANGER;
    },
    cssVars() {
      const autoCognitionFrameDisplay = this.hasManualAssessment
        ? "none"
        : "block";
      return {
        "--auto-cognition-frame-display": autoCognitionFrameDisplay,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.vessel-course-icon {
  --auto-cognition-frame-display: block;
  ::v-deep .auto-cognition-frame {
    display: var(--auto-cognition-frame-display);
  }
}
</style>
